import React from 'react';
import { FiHelpCircle } from 'react-icons/fi';

import { Container } from './styles';

interface HelpProps {
  text: string;
  value: string;
}

const Help: React.FC<HelpProps> = ({ text, value }) => {
  return (
    <Container>
      <div>
        <span>{text}</span>
        <strong>{value}</strong>
      </div>
      <FiHelpCircle />
    </Container>
  );
};

export default Help;
